export const team25 = [{
  "year": 2025,
  "CoreTeam": [
    {
      "Position": "Chairperson",
      "Name": "Ronak Agrawal",
      "SocialHandles": [
        "https://www.linkedin.com/in/ronak-agrawal-823721292/"
      ],
      "ImgPath": "Ronak.jpg"
    },
    {
      "Position": "Vice Chairperson",
      "Name": "Renuka Poladi",
      "SocialHandles": [
        "https://www.linkedin.com/in/renuka-rao-poladi-4412742a0/"
      ],
      "ImgPath": "Renuka.jpg"
    },
    {
      "Position": "Secretary",
      "Name": "J. Abhinav Sai",
      "SocialHandles": [
        "https://www.linkedin.com/in/abhinavsai07/"
      ],
      "ImgPath": "Abhinav.jpg"
    },
    {
      "Position": "Treasurer",
      "Name": "Abhilash Moturi",
      "SocialHandles": [
        "https://www.linkedin.com/in/moturi-abhilash-39280525a/"
      ],
      "ImgPath": "Abhilash.jpg"
    },
    {
      "Position": "Membership Chair",
      "Name": "P. Shivalini Reddy",
      "SocialHandles": [
        "https://www.linkedin.com/in/panyala-shivalini-reddy-16bb47291/"
      ],
      "ImgPath": "Shivalini.jpg"
    },
    {
      "Position": "Webmaster",
      "Name": "Ch. Anand",
      "SocialHandles": [
        "https://www.linkedin.com/in/chedapangu-anand-a833ab2a0/"
      ],
      "ImgPath": "Anand.jpg"
    }
  ],
  "TeamHeads": [
    {
      "Position": "Social Media Head",
      "Name": "K. Sai Manish",
      "SocialHandles": [
        "https://www.linkedin.com/in/kannaiahgari-manish/"
      ],
      "ImgPath": "Sai_Manish.jpg"
    },
    {
      "Position": "Events & PR Head",
      "Name": "P. Anvitha Reddy",
      "SocialHandles": [
        "https://www.linkedin.com/in/anvitha-reddy-puli-b34082293/"
      ],
      "ImgPath": "Anvitha.jpg"
    },
    {
      "Position": "Technical Head",
      "Name": "Siddartha Samisetty",
      "SocialHandles": [
        "https://www.linkedin.com/in/siddartha-samisetty-b510992a0/"
      ],
      "ImgPath": "Siddartha.jpg"
    },
    {
      "Position": "Design Team Head",
      "Name": "M. Sree Harshini",
      "SocialHandles": [
        "https://www.linkedin.com/in/sree-harshini-mandala-31aa54292"
      ],
      "ImgPath": "Harshini.jpg"
    },
    {
      "Position": "Coding Team Head",
      "Name": "Abhilash Banda",
      "SocialHandles": [
        "https://www.linkedin.com/in/abhilash-banda-50361627a/"
      ],
      "ImgPath": "Abhilash_B.jpg"
    },
    {
      "Position": "Creative Team Head",
      "Name": "Sai Bhanu Palla",
      "SocialHandles": [
        "https://www.linkedin.com/in/saibhanu-palla/"
      ],
      "ImgPath": "Bhanu.jpg"
    }
  ],
  "Volunteers": [
    {
      "Name": "J.Srikar",
      "Mail": "srikarjanjirala92@gmail.com",
      "Team": "Technical ",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/srikar-janjirala-08a50728b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
      "Name": "C. Yashwanth Chandra",
      "Mail": "yashwanthchandra54@gmail.com",
      "Team": "Technical",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/yashwanth-chandra-7242042a0?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
      "Name": "B.Vedasi",
      "Mail": "bvedasichowdary@gmail.com",
      "Team": "Technical ",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/vedasi-balla-454337283/"
    },
    {
      "Name": "Vedvardhan Gyanmote",
      "Mail": "ved08.dev@gmail.com",
      "Team": "Technical",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/vedvardhan-gyanmote-566995201/"
    },
    {
      "Name": "A. Mani Shankar",
      "Mail": "manishankar.ams@gmail.com",
      "Team": "Technical",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/mani-shankar-amudalapalli"
    },
    {
      "Name": "Juluri Shradha",
      "Mail": "shradhajuluri7@gmail.com",
      "Team": "Events and PR",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/juluri-shradha-3103a131a/"
    },
    {
      "Name": "N.Siri Chandana",
      "Mail": "sirichandananallamothu.7@gmail.com",
      "Team": "Events and PR",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/siri-chandana-nallamothu/"
    },
    {
      "Name": "G. Shreshta",
      "Mail": "saishreshta.gudipati@gmail.com",
      "Team": "Events and PR",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/saishreshta-gudipati-376348301/"
    },
    {
      "Name": "P sneha",
      "Mail": "peddisneha01@gmail.com",
      "Team": "Events and PR",
      "imgPath": "avatar.png",
      "linkedin": "https://linkedin.com/in/peddi-sneha-85a078352"
    },
    {
      "Name": "D. Nikitha Reddy",
      "Mail": "dandanikithareddy@gmail.com",
      "Team": "Social Media",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/nikitha-reddy-danda"
    },
    {
      "Name": "Aryan Singh Salaria",
      "Mail": "aryansinghsalaria0150@gmail.com",
      "Team": "Social Media",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/aryan-singh-salaria-706436337/"
    },
    {
      "Name": "A.Srihitha",
      "Mail": "srihitha3456@gmail.com",
      "Team": "Social Media",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/srihitha-annapaneni-581103306/"
    },
    {
      "Name": "I. Deena Sreshta",
      "Mail": "intideenasreshta@gmail.com",
      "Team": "Social Media",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/deena-sreshta/"
    },
    {
      "Name": "S.Lasya Priya",
      "Mail": "lasya1626@gmail.com",
      "Team": "Design",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/lasya-priya-b2b34729a"
    },
    {
      "Name": "Sreeamritha.M",
      "Mail": "mailsree2005@gmail.com",
      "Team": "Design",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/amritha-reddy-78a001306/"
    },
    {
      "Name": "K.Harshitha",
      "Mail": "harshithakaredla@gmail.com",
      "Team": "Design",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/harshitha-reddy-b3b29728b/"
    },
    {
      "Name": "Kolli Bavitha",
      "Mail": "bavitha2042006@gmail.com",
      "Team": "Design",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/bavitha-kolli-9544b4226/"
    },
    {
      "Name":"T.Murali",
      "Mail": "mtejomurtula@gmail.com",
      "Team": "Design",
      "imgPath": "avatar.png",  
      "linkedin": "https://www.linkedin.com/in/murali-samant-tejomurtula-51588231a/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
      "Name": "B.V.Swapanthi",
      "Mail": "swapanthibv@gmail.com",
      "Team": "Design",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/venkata-swapanthi-bommidi-30733a2a9/"
    },
    {
      "Name": "K.Vennela",
      "Mail": "vennalakalvakuntla@gmail.com",
      "Team": "Creative",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/vennela-kalvakuntla-69a8b0337/"
    },
    {
      "Name": "Dhanala Karthik",
      "Mail": "karthik.dhanala15@gmail.com",
      "Team": "Creative",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/karthik-dhanala-b2261628b/"
    },
    {
      "Name": "T Sushank",
      "Mail": "sushankthatipally@gmail.com",
      "Team": "Creative",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/sushank-thatipally-816262314/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
    },
    {
      "Name": "R. Chandrahaas",
      "Mail": "reddyshettychandrahaas@gmail.com",
      "Team": "Creative",
      "imgPath": "avatar.png",
      "linkedin": "https://www.linkedin.com/in/reddyshetty-chandrahaas-1179a5337/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },{
    "Name": "Madikuntawar Srikar",
    "Mail": "srikarmadikuntawar@gmail.com",
    "Team": "Coding",
    "linkedin": "https://www.linkedin.com/in/srikar-madikuntawar-3010srikar"
  },
  {
    "Name": "Vighnesh Vangari",
    "Mail": "vangarivighnesh@gmail.com",
    "Team": "Coding",
    "linkedin": "https://www.linkedin.com/in/vighneshvangari"
  },
  {
    "Name": "Peddinti Veerendra Satya Sai Vinay",
    "Mail": "pvssvinay9@gmail.com",
    "Team": "Coding",
    "linkedin": "https://in.linkedin.com/in/vinay-peddinti"
  },
  {
    "Name": "Kalyan Tingani",
    "Mail": "kalyantingani@gmail.com",
    "Team": "Coding",
    "linkedin": "https://in.linkedin.com/in/kalyan-tingani1"
  },
  {
    "Name": "J. Abhinav Sai",
    "Mail": "Abhinavsai.janipireddy@gmail.com",
    "Team": "Coding",
    "linkedin": "https://www.linkedin.com/in/abhinavsai07/"
  },
  {
    "Name": "Ronak Agrawal",
    "Mail": "reachoutron@gmail.com",
    "Team": "Coding",
    "linkedin": "https://www.linkedin.com/in/ronak-agrawal-823721292/"
  },
  {
    "Name": "Yerra Abhishek",
    "Mail": "abhishekyerra333@gmail.com",
    "Team": "Coding",
    "linkedin": "https://www.linkedin.com/in/abhishek-yerra-522204266"
  },
  {
    "Name": "Abhilash Banda",
    "Mail": "abhilashbanda7@gmail.com",
    "Team": "Coding",
    "linkedin": "https://www.linkedin.com/in/abhilash-banda-50361627a/"
  }
  ],
    "Test":[{
        "Name":"Anand",
        "Desig":"Webmaster(2024-2025)",
        "Content":"ACM VNRVJIET is the best platform that any student could have, to experience life as a student to the fullest. The chapter is always devoted to finding the requirements of the students in order to bridge the gap between academics and overall growth of the student to help them become a better individual and excel as a team player and stand out from the competitive world around them. It successfully brought up many highly acclaimed programs with great zeal. I am a grateful member of this chapter which helped me to kick start, understand and explore many things that helped me grow both personally and professionally. Everything about this chapter fascinated me, inspired me to join as a volunteer and become a part of its vision and mission.",
        "imgPath":"Anand.jpg"
    },
    {
        "Name":"Ronak Agrawal",
        "Desig":"Chairperson(2024-2025)",
        "Content":"My experience as a volunteer for ACM VNRVJIET is exceptional. This is one of my finest B.Tech life experiences. This chapter has taught me a lot of new things. From a less confident, striving introvert to someone who can confidently showcase their skills and manage a team with 20 different mindsets. By organising various events, I have honed my management and leadership abilities. I'm extremely grateful for the effective work culture and teamwork here, which contribute to the success of events. I'm very thankful to all of my seniors for assisting me in quickly sorting things out. I am a better individual owing to ACM.",
        "imgPath":"Ronak.jpg"
    },
    {
        "Name":"Renuka",
        "Desig":"Vice Chairperson(2024-2025)",
        "Content":"It is believed that a person’s life is molded in the early 20s and it is very important to be in the right place. In that case, I am glad that ACM VNRVJIET happened to me. ACM VNRVJIET has been a great contributor to the development of my personality. I have established my leadership, time management, and team skills and have also been able to advance these skills. From participating in events to conducting events through ACM VNRVJIET, my learnings and experiences will always be my fundamentals for any milestone I achieve.",
        "imgPath":"Renuka.jpg"
    },
    {
        "Name":"Abhilash",
        "Desig":"Treasurer(2024-2025)",
        "Content":"It is believed that a person’s life is molded in the early 20s and it is very important to be in the right place. In that case, I am glad that ACM VNRVJIET happened to me. ACM VNRVJIET has been a great contributor to the development of my personality. I have established my leadership, time management, and team skills and have also been able to advance these skills. From participating in events to conducting events through ACM VNRVJIET, my learnings and experiences will always be my fundamentals for any milestone I achieve.",
        "imgPath":"Abhilash.jpg"
    },
     {
        "Name":"Abhinav",
        "Desig":"Secretary(2024-2025)",
        "Content":"It is believed that a person’s life is molded in the early 20s and it is very important to be in the right place. In that case, I am glad that ACM VNRVJIET happened to me. ACM VNRVJIET has been a great contributor to the development of my personality. I have established my leadership, time management, and team skills and have also been able to advance these skills. From participating in events to conducting events through ACM VNRVJIET, my learnings and experiences will always be my fundamentals for any milestone I achieve.",
        "imgPath":"Abhinav.jpg"
    }
  ]
}
]